import React from 'react'
import {Link} from 'react-router-dom'

import {Helmet} from 'react-helmet'

import { store } from '../../store'

import {Grid, Row, Col, FormControl} from 'react-bootstrap'

const initialState = {
  url: '',
  name: '',
  check: 'website_inp_url_inp',
  one: 'temp',
  two: 'temp',
  three: 'temp',
  error: false,
  mouseOverBtn: false,
  template: '',
  imgsecond: 'loading',
  imgfirst: 'loading'
}

class Template extends React.Component {
  constructor(props){
    super()
    this.state = initialState;
  }
componentDidMount() {
  this.setState({
    name: store.getState().website.name,
    url: store.getState().website.url,
    template: store.getState().website.template
  })
}
changetoCreate = () => {
  if(
    store.getState().website.template !== '' &&
    this.state.template
    )
  {
    this.props.onRouteChange('addData')
  }
  else
  {
    this.setState({error: true})
  }
}
render() {
const changeTemplate = (theme) => {
  if(this.state.template === theme)
  {
    this.props.template('')
    this.setState({template: ''})
  }
  else {
    this.props.template(theme)
    if(theme === 'first') {
      this.props.onCustomization([
        {font: "Lato", size: "28", color: "#000000", class: "profile_name"},
        {font: "Dancing Script", size: "24", color: "#4a90e2", class: "profile_bio"},
        {font: "Open Sans", size: "18", color: "#000000", class: "about"},
        {color: "#000", class: "icons"},
        {color: "#eeefff", opacity: "1", class: "background"}
        ])
    }
    else if(theme === 'second') {
      this.props.onCustomization([
        {font: "Dancing Script", size: "36", color: "#ffffff", class: "profile_name"},
        {font: "Righteous", size: "22", color: "#f5a623", class: "profile_bio"},
        {font: "Lora", size: "20", color: "#ffffff", class: "about"},
        {color: "#fff", class: "icons"},
        {color: "#000000", opacity: "0.4", class: "background"}
        ])
    }
    else if(theme === 'third') {
      this.props.onCustomization([
        {font: "Lato", size: "36", color: "#ffffff", class: "profile_name"},
        {font: "Vibur", size: "24", color: "#f5a623", class: "profile_bio"},
        {font: "Open Sans", size: "20", color: "#ffffff", class: "about"},
        {color: "#fff", class: "icons"},
        {color: "#16002a", opacity: "0.4", class: "background"}
        ])
    }
    else if(theme === 'fourth') {
      this.props.onCustomization([
        {font: "Abel", size: "72", color: "#f5a623", class: "profile_name"},
        {font: "Abel", size: "36", color: "#8bff5d", class: "profile_bio"},
        {font: "Abel", size: "20", color: "#ffffff", class: "about"},
        {color: "#fff", class: "icons"},
        {color: "#000000", opacity: "0.2", class: "background"}
        ])
    }
    else if(theme === 'fifth') {
      this.props.onCustomization([
        {font: "Abel", size: "72", color: "#f5a623", class: "profile_name"},
        {font: "Abel", size: "36", color: "#8bff5d", class: "profile_bio"},
        {font: "Abel", size: "20", color: "#ffffff", class: "about"},
        {color: "#fff", class: "icons"},
        {color: "#000000", opacity: "0.3", class: "background"}
        ])
    }
    this.setState({template: theme})
  }
}
  let err_msg = null
  if(this.state.error === true) {
    err_msg = <div className="save">
              <div className="save_error">
              <span
              onClick={()=>this.setState({error:false})} href="#" className="close"/>
              Error: Something went wrong
              </div>
              </div>
  }
      return (
        <div className="form_bg website_bg">
          <Helmet>
            <title>Create Profile Site</title>  
          <meta name="description" content="Start creating your profile site by picking a stunning theme" />
          <meta name="keyword" content="create profile site, free website profile, create vieww profile, create profiles fast" />
          </Helmet>
        {err_msg}
          <Grid>
          <Row>
          <Col lg={12} md={12} sm={12} xs={12} className={`${this.state.three}`}>
          <div>
          <Row className="fullpage_theme">
          <Col lg={12} md={12} sm={12} xs={12}>
          <Link to={'/'}><span href='#' className="go_back go_back_b go_dark"/></Link>
            <h3 className="temp_headings">Select a Theme</h3>
            </Col>
            <Col lg={12} md={12} sm={12} xs={12}>
            <div  className="themes">
            <div className="theme_select" onClick={(theme)=>changeTemplate('fourth')}>
             <div className={
              this.state.imgsecond === 'loaded'
              ? 'theme_inside'
              : 'theme_inside_blur'
              }>
             <img onLoad={()=> this.setState({imgsecond: 'loaded'})} className={
              this.state.template === 'fourth'
              ? 'theme_img_active'
              : 'theme_img'
              }  src={`${process.env.REACT_APP_API}/img/fourth.jpg`} alt="theme_img" />
             </div>
            </div>


            <div className="theme_select" onClick={(theme)=>changeTemplate('fifth')}>
             <div className={
              this.state.imgsecond === 'loaded'
              ? 'theme_inside'
              : 'theme_inside_blur'
              }>
             <img onLoad={()=> this.setState({imgsecond: 'loaded'})} className={
              this.state.template === 'fifth'
              ? 'theme_img_active'
              : 'theme_img'
              }  src={`${process.env.REACT_APP_API}/img/fifth.jpg`} alt="theme_img" />
             </div>
            </div>
             </div>
             </Col>
             <Col lg={12} md={12} sm={12} xs={12}>
            <div  className="themes">
            <div className="theme_select" onClick={(theme)=>changeTemplate('first')}>
             <div className={
              this.state.imgfirst === 'loaded'
              ? 'theme_inside'
              : 'theme_inside_blur'
              }>
             <img onLoad={()=> this.setState({imgfirst: 'loaded'})} className={
              this.state.template === 'first'
              ? 'theme_img_active'
              : 'theme_img'
              } src={`${process.env.REACT_APP_API}/img/first.jpg`} alt="theme_img" />
            </div>
             </div>
            <div className="theme_select" onClick={(theme)=>changeTemplate('second')}>
             <div className={
              this.state.imgsecond === 'loaded'
              ? 'theme_inside'
              : 'theme_inside_blur'
              }>
             <img onLoad={()=> this.setState({imgsecond: 'loaded'})} className={
              this.state.template === 'second'
              ? 'theme_img_active'
              : 'theme_img'
              }  src={`${process.env.REACT_APP_API}/img/second.jpg`} alt="theme_img" />
             </div>
            </div>
            </div>
            </Col>
            <Col lg={12} md={12} sm={12} xs={12}>
            <div  className="themes">
            <div className="theme_select" onClick={(theme)=>changeTemplate('third')}>
             <div className={
              this.state.imgsecond === 'loaded'
              ? 'theme_inside'
              : 'theme_inside_blur'
              }>
             <img onLoad={()=> this.setState({imgsecond: 'loaded'})} className={
              this.state.template === 'third'
              ? 'theme_img_active'
              : 'theme_img'
              }  src={`${process.env.REACT_APP_API}/img/third.jpg`} alt="theme_img" />
             </div>
            </div>
            <div className="theme_select">
            <div className='theme_inside'>
            <div className='comming_soon_theme'>Comming Soon</div>
            </div>
            </div>
            </div>
            </Col>
             </Row>
             <div className="hl_btn_container website_box">
            <button className="btn_new" onClick={this.changetoCreate}>Start</button>
         </div>
            </div>
          </Col>
          </Row>
          </Grid>

      </div>
      );
}

}
export default Template;